// interval is in milliseconds
export const POLLING_INTERVAL_MS = 5000;